import Swal from 'sweetalert2';
import React, { useEffect, useState } from "react";
import { useGuestContext } from '../../../contexts/GuestContext';
import {
    Form,
    Table,
  } from "react-bootstrap";
  import axios from 'axios'
function CheckInConfirmation({details}) {
    const [alert, setAlert] = React.useState(null);
    const { language } = useGuestContext();

    const htmlContent = `
    <div style="overflow-x: auto;">
        <table style="width: 100%; border-collapse: collapse;">
            <thead>
                <tr style="background-color: #f2f2f2;">
                    <th style="text-align: left; padding: 8px;">${language === "English" ? "Field" : "字段"}</th>
                    <th style="text-align: center; padding: 8px;">${language === "English" ? "Value" : "值"}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td style="text-align: left; padding: 8px;">${language === "English" ? "Guest ID" : "客人编号"}</td>
                    <td style="text-align: center; padding: 8px;">${details.guestId}</td>
                </tr>
                <tr>
                    <td style="text-align: left; padding: 8px;">${language === "English" ? "Name" : "姓名"}</td>
                    <td style="text-align: center; padding: 8px;">${details.firstname} ${details.lastname}</td>
                </tr>
                <tr>
                    <td style="text-align: left; padding: 8px;">${language === "English" ? "Chinese Name" : "中文名"}</td>
                    <td style="text-align: center; padding: 8px;">${details.chinesename ? details.chinesename : (language === "English" ? "Not provided" : "無")}</td>
                </tr>
                <tr>
                    <td style="text-align: left; padding: 8px;">${language === "English" ? "Phone" : "电话"}</td>
                    <td style="text-align: center; padding: 8px;">${details.phone}</td>
                </tr>
                <tr>
                    <td style="text-align: left; padding: 8px;">${language === "English" ? "Email" : "电子邮件"}</td>
                    <td style="text-align: center; padding: 8px;">${details.email}</td>
                </tr>
                 <tr>
                    <td style="text-align: left; padding: 8px;">${language === "English" ? "Group Size" : "隨行人數"}</td>
                    <td style="text-align: center; padding: 8px;">${details.relatives !== undefined && details.relatives !== null ? details.relatives : 1}</td>
                </tr>
            </tbody>
        </table>
    </div>
`;


    const hideAlert = () => {
        setAlert(null);
    };

    Swal.fire({
        title: language === "English" ? "You are about to Check in" : "報到確認",
        html: htmlContent + `
            <div style="margin-top: 20px;">
                <label for="groupSize" style="display: block; margin-bottom: 8px; font-weight: bold;">
                    ${language === "English" ? "Group Size" : "隨行人數"}
                </label>
                <select id="groupSize" style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 4px; font-size: 16px; background-color: white;">
                    <option value="" style="font-size: 16px; padding: 8px;">${language === "English" ? "Select Group Size" : "選擇隨行人數"}</option>
                    ${Array.from({ length: 15 }, (_, i) => `<option value="${i + 1}" style="font-size: 16px; padding: 8px;">${i + 1} ppl</option>`).join('')}
                </select>
            </div>
        `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: language === "English" ? "Yes, Check me in" : "完成報到",
        cancelButtonText: language === "English" ? "Cancel" : "取消報到",
        allowOutsideClick: false,
        preConfirm: () => {
            const groupSize = document.getElementById('groupSize').value;
            if (!groupSize) {
                Swal.showValidationMessage(language === "English" ? "Please select a group size" : "請選擇隨行人數");
                return false;
            }
            return { groupSize: parseInt(groupSize) };
        }
    }).then((result) => {
        if (result.isConfirmed && result.value) {
            const groupSize = result.value.groupSize;
            // Send API request to backend
            axios.post(`${process.env.REACT_APP_SERVER_URL}/event/checkinconfirm`, {
                guestid: details.guestId,
                groupSize: groupSize
            })
                .then(response => {
                    if (response.data && response.data.status === 'success') {
                        Swal.fire({
                            title: language === "English" ? `Check-in Successful` : `報到成功`,
                            text: language === "English" ? `Guest ID: ${details.guestId} has been checked in for a group of ${groupSize}.` : `ID為${details.guestId}的居士已報到，隨行人數：${groupSize}。`,
                            icon: 'success',
                            confirmButtonText: 'OK'
                        }).then(() => {
                            window.location.href = '/checkinSearch'; // Redirect or any other action after success
                        });
                    } else {
                        // Handle any other status or error
                        Swal.fire('Error', 'An error occurred during check-in', 'error');
                    }
                })
                .catch(error => {
                    // Handle HTTP errors
                    Swal.fire('Error', 'An error occurred while sending data', 'error');
                });
        } else if (result.isDismissed) {
            window.location.href = '/checkinSearch';
        }
    });
    

    return (
        <>
            {alert}
        </>
    )
}
export default CheckInConfirmation